import clsx from 'clsx'
import type { FunctionComponent, MouseEventHandler, ReactNode } from 'react'
import styles from './AlertPopup.module.sass'
import { Box } from './Box'
import { Icon } from './Icon'

export type AlertPopupProps = {
	type: 'default' | 'success' | 'error'
	children: ReactNode
	onClickClose?: MouseEventHandler<HTMLButtonElement>
	isOpen: boolean
}

export const AlertPopup: FunctionComponent<AlertPopupProps> = ({
	type,
	children,
	onClickClose,
	isOpen,
}) => {
	return (
		<div className={clsx(styles.wrapper, styles[`is_${type}`], isOpen && styles.isOpen)}>
			<div className={styles.inner}>
				<Box view="wide" posRelative largePadding>
					<div className={styles.content}>{children}</div>
					<button type="button" className={styles.close} onClick={onClickClose} aria-label="close">
						<Icon name="close" />
					</button>
				</Box>
			</div>
		</div>
	)
}
